// Local date helpers (YYYY-MM-DD in local time, matching the picker's backend format).
export function todayIso(): string {
  const d = new Date();
  return toIso(d);
}

export function yesterdayIso(): string {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return toIso(d);
}

export function toIso(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

// Clamp a YYYY-MM-DD string to at most today; invalid -> null.
export function clampDate(value: string | null): string | null {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const today = todayIso();
  return value > today ? today : value;
}
